var exports = {
  "qI": "listContainer__h2BfBq",
  "jD": "skeletonItem__wfzi5V",
  "b6": "skeletonHeader__mCI0Rn",
  "Aj": "skeletonDescription__vFu_R9",
  "FB": "skeletonMetadata__qMEizU",
};

module.exports = exports;
